import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentsListErrorState = ({
  onTryAgain
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "column",
    padding: "1000",
    textAlign: "center",
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-default",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "errors/general",
      width: "40%",
      className: "m-y-6"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentHistory.panel.enrollment-list.loadingError"
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: onTryAgain,
      use: "tertiary-light",
      className: "m-top-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.enrollment-list.tryAgain"
      })
    })]
  });
};
export default EnrollmentsListErrorState;